import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFilter'
})
export class TimeFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    let dataTime = new Date().getTime();

    let praiseTime = value;

    value = Math.floor(((dataTime / 1000 - value) / 60)) + "分钟前";
    if (parseInt(value) > 59) {
      value = parseInt(value);
      value = Math.floor(value / 60) + "小时前";
      if (parseInt(value) > 24) {
        value = parseInt(value);
        value = Math.floor(value / 24) + "天前";
        if (parseInt(value) > 30) {
          let cc = new Date(parseInt(praiseTime) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
          value = cc.substring(0, cc.indexOf(" "), );
        }
      }
    }
    return value;
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/pipe/time-filter.pipe.ts